import { useAuthStore } from './store'

export function useAuth(): ReturnType<typeof useAuthStore> {
  return useAuthStore()
}
